import React, { useState, useEffect } from "react";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useUpdateData } from "hooks/useApiHooks";
import { useCanvasHandler } from "hooks/useCanvasHandler";

const ChangeOrderDate = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/reservation";

  console.log("ChangeOrderDate initialData", initialData);

  // State untuk form data
  const [formData, setFormData] = useState({
    reservation_date: initialData?.reservation_date || "",
  });

  // Sinkronisasi jika `initialData` berubah
  useEffect(() => {
    if (initialData?.reservation_date) {
      setFormData({ reservation_date: initialData.reservation_date });
    }
  }, [initialData]);

  // Gunakan `useUpdateData` dengan `updateData`
  const { updateData: updateBooking } = useUpdateData(
    `${API_URL}/${initialData?.id}/move`
  );

  const { handleSuccessToast, handleError } = useCanvasHandler();

  // Gunakan `useSubmitHandler` untuk mengelola submit
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    updateBooking,
    async () => {
      // handleSuccessToast(true, "Tanggal booking berhasil diubah!");
      onSuccess();
    },
    (error) => {
      handleError(true, error || "Gagal mengubah tanggal booking.");
      onError?.(error);
    }
  );

  const handleChange = useFormChangeHandler(setFormData);

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData, e);
  };

  return (
    <div className="container-fluid mt-4">
      {/* tampilkan detail data yg lain */}
      <div className="card mb-4">
        <div className="card-body">
          <h5 className="card-title">Detail Booking</h5>
          <div className="row">
            <div className="col-6">
              <p className="card-text">
                <strong>Code</strong> : {initialData?.code}
              </p>
              <p className="card-text">
                <strong>Current Date</strong> : {initialData?.reservation_date}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="card mb-4">
        <div className="card-body">
          <form
            onSubmit={handleBeforeSubmit}
            className="d-flex flex-column gap-3"
          >
            {/* Input Tanggal Booking */}
            <div className="form-group">
              <label htmlFor="booking_date" className="mb-2">
                Tanggal Booking
              </label>
              <input
                type="date"
                id="booking_date"
                name="reservation_date"
                value={formData.reservation_date}
                onChange={handleChange}
                className="form-control"
                required
                disabled={isSubmitting} // Nonaktifkan saat loading
              />
              {formError?.reservation_date && (
                <small className="text-danger">
                  {formError.reservation_date}
                </small>
              )}
            </div>

            {/* Tombol Submit */}
            <div className="form-group d-grid">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Memproses..." : "Simpan"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangeOrderDate;
